// Simple local lorem text generator library
// Usage: lorem( lengthInChars ) => string of approximately the requested length

const WORDS = (
  'lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore ' +
  'et dolore magna aliqua ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut ' +
  'aliquip ex ea commodo consequat duis aute irure dolor in reprehenderit in voluptate velit esse cillum ' +
  'dolore eu fugiat nulla pariatur excepteur sint occaecat cupidatat non proident sunt in culpa qui ' +
  'officia deserunt mollit anim id est laborum'
).split(/\s+/);

/**
 * Generate lorem-like text with approximately the specified character length.
 * The text will not cut words in half; it may slightly exceed the requested length.
 */
export function lorem(length: number, startWithLoremIpsum: boolean = true): string {
  const target = Math.max(1, Math.floor(length || 1));
  const words: string[] = [];
  let i = 0;
  if (startWithLoremIpsum) {
    words.push('Lorem', 'ipsum');
  }
  while (words.join(' ').length < target) {
    words.push(WORDS[i % WORDS.length]);
    i++;
  }
  let text = words.join(' ');
  // Ensure it ends with a period for readability
  if (!/[\.!?]$/.test(text)) {
    text += '.';
  }
  return text;
}
